import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStatusOk = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 16,
		height: 16,
		rx: 8,
		fill: "#7CDEAF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5 8.5L7 10.5L11.5 5",
		stroke: "white",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})]
});
export default SvgStatusOk;
